import { useEffect, useState } from "react";
import { auth } from "../firebase"; // make sure this exports your Firebase client `auth`

export default function useDisplayNames() {
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const fetchDisplayNames = async () => {
      try {
        setLoading(true);

        const user = auth.currentUser;
        if (!user) throw new Error("No authenticated user");

        const idToken = await user.getIdToken();

        const res = await fetch("https://getdisplaynames-5dhfwyjvzq-uc.a.run.app", {
          headers: {
            Authorization: `Bearer ${idToken}`,
          },
        });

        const body = await res.text(); // ✅ consume once
        if (!res.ok) {
          throw new Error(`Failed to fetch display names: ${body}`);
        }

        let names;
        try {
          names = JSON.parse(body);
        } catch (e) {
          throw new Error("Response was not valid JSON");
        }

        if (!cancelled) {
          setPlayers(names.map((name, idx) => ({ id: idx.toString(), displayName: name })));
        }
      } catch (err) {
        console.error("❌ Error fetching display names:", err);
        if (!cancelled) setPlayers([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchDisplayNames();

    return () => {
      cancelled = true;
    };
  }, []);

  return { players, loading };
}
